import { NgModule } from '@angular/core';
import { PfeNestedActionsService } from './nested-actions/nested-actions.service';
import { PfeActionsService } from './pfe-actions.service';
import { PfeResetStateService } from './reset-state/reset-state.service';
import { PfeRewindHistoryService } from './rewind-history/rewind-history.service';
import { PfeTriggerServiceActivatorsService } from './trigger-service-activators/trigger-service-activators.service';
import { PfeUpdateStateOnBackendService } from './update-state-on-backend/update-state-on-backend.service';
import { PfeUpdateStateValuesService } from './update-state-values/update-state-values.service';

@NgModule({
  providers: [
    PfeActionsService,
    PfeUpdateStateValuesService,
    PfeUpdateStateOnBackendService,
    PfeTriggerServiceActivatorsService,
    PfeNestedActionsService,
    PfeRewindHistoryService,
    PfeResetStateService,
  ],
})
export class PfeActionsModule {}
